import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Target;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { jsx } from '@instructure/emotion';
import { Component } from 'react';
import PropTypes from 'prop-types';
import '../../common/ellipsePolyfill';
import Canvas from '../../common/Canvas';
import canvasPropTypes, { pickProps, defaultProps } from '../../common/Canvas/propTypes';
import generateComponentTheme from './theme';
import generateStyle from './styles';
import { withStyleOverrides } from '@instructure/quiz-common';
var Target = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Target = /*#__PURE__*/function (_Component) {
  function Target() {
    var _this2;
    _classCallCheck(this, Target);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, Target, [].concat(args));
    _defineProperty(_this2, "canvasRef", function (node) {
      _this2.canvas = node;
    });
    _defineProperty(_this2, "drawShape", function () {
      var coordinates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (coordinates.length === 1) {
        var internalGap = 2;
        var pointA = {
          x: coordinates[0].x - internalGap,
          y: coordinates[0].y - internalGap
        };
        var pointB = {
          x: coordinates[0].x + internalGap,
          y: coordinates[0].y + internalGap
        };
        var radiusX = (pointB.x - pointA.x) * 0.5;
        var radiusY = (pointB.y - pointA.y) * 0.5;
        var centerX = pointA.x + radiusX;
        var centerY = pointA.y + radiusY;
        var externalGap = 10;
        _this2.__drawEllipse(
        // internal circle
        radiusX, radiusY, centerX, centerY);
        _this2.__drawEllipse(
        // external circle
        radiusX + externalGap, radiusY + externalGap, centerX, centerY);
      }
    });
    // ===========
    //   ACTIONS
    // ===========
    _defineProperty(_this2, "onMouseUp", function (e) {
      var coordinates = _this2.__getCoordinates(e);
      _this2.canvas.drawShape(coordinates);
      _this2.canvas.stopDrawing(coordinates);
    });
    // override the default behaviour that's not needed for this type
    _defineProperty(_this2, "onMouseOut", function () {});
    return _this2;
  }
  _inherits(Target, _Component);
  return _createClass(Target, [{
    key: "__getCoordinates",
    value: function __getCoordinates(e) {
      var x = e.nativeEvent.offsetX;
      var y = e.nativeEvent.offsetY;
      return [{
        x: x,
        y: y
      }];
    }
  }, {
    key: "__drawEllipse",
    value: function __drawEllipse(radiusX, radiusY, centerX, centerY) {
      var ctx = this.canvas.canvasElement.getContext('2d');
      this.canvas.setStrokeStyle();
      ctx.globalAlpha = 1;
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.ellipse(centerX, centerY, Math.abs(radiusX), Math.abs(radiusY), 0, 0, 2 * Math.PI);
      ctx.closePath();
      ctx.shadowColor = this.props.styles.shadowColor;
      ctx.shadowBlur = 1;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      ctx.stroke(); // render border
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Canvas, Object.assign({
        realRef: this.canvasRef,
        drawShape: this.drawShape,
        onMouseUp: this.onMouseUp,
        onMouseOut: this.onMouseOut
      }, pickProps(this.props)));
    }
  }]);
}(Component), _defineProperty(_Target, "displayName", 'Target'), _defineProperty(_Target, "componentId", "Quizzes".concat(_Target.displayName)), _defineProperty(_Target, "propTypes", _objectSpread(_objectSpread({}, canvasPropTypes), {
  styles: PropTypes.object
})), _defineProperty(_Target, "defaultProps", defaultProps), _Target)) || _class);
export { Target as default };